import { render, staticRenderFns } from "./StudentLayout.vue?vue&type=template&id=7daa7ff0&lang=pug&"
import script from "./StudentLayout.vue?vue&type=script&lang=js&"
export * from "./StudentLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports